import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id A2839B3A-760A-4061-80CA-41B3FA5817E0
 * name chart-gantt
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-gantt.svg
 * tags
 * - Math 
 */
export const ChartGanttIcon = createSvgIcon(<><path d="M2,5H10V2H12V22H10V18H6V15H10V13H4V10H10V8H2V5M14,5H17V8H14V5M14,10H19V13H14V10M14,15H22V18H14V15Z" /></>, 'ChartGanttIcon');
export default ChartGanttIcon